"use client";

import { Button } from "@/app/components/shadcn/button";
import { UserCircle2 } from "lucide-react";
import Link from "next/link";

interface AuthRequiredContentProps {
  title?: string;
  description?: string;
  continueHref?: string;
  onContinueClick?: () => void;
  /** Giriş sonrası dönülecek yol. Verilmezse `continueHref` kullanılır. */
  loginRedirect?: string;
}

const AuthRequiredContent = ({
  title = "Tozlu Hesabın Yok Mu?",
  description = "Kayıt olarak siparişlerini daha kolay takip edebilirsin.",
  continueHref = "/account/checkout",
  onContinueClick,
  loginRedirect,
}: AuthRequiredContentProps) => {
  // Giriş linki `redirect` parametresi taşımıyordu; LoginForm bu parametreyi
  // bulamayınca `router.replace("/")` çalışıyor ve kullanıcı ödeme akışının
  // ortasından ana sayfaya düşüyordu. Hedef, "kayıt olmadan devam et"in
  // gittiği yerle aynı olmalı.
  const loginHref = `/auth/login?redirect=${encodeURIComponent(
    loginRedirect ?? continueHref,
  )}`;

  return (
    <div className="px-6 pt-4 pb-12 flex flex-col items-center gap-6">
      <UserCircle2 size={48} className="text-gray-300" />

      <div className="text-center">
        <h2 className="text-lg font-semibold text-gray-900">{title}</h2>
        <p className="text-sm text-gray-500 mt-1">{description}</p>
      </div>

      <div className="flex flex-col gap-3 w-full">
        {onContinueClick ? (
          <Button
            variant="outline"
            className="w-full h-12 text-sm font-medium"
            onClick={onContinueClick}
          >
            Kayıt Olmadan Devam Et
          </Button>
        ) : (
          <Link href={continueHref} className="w-full">
            <Button variant="outline" className="w-full h-12 text-sm font-medium">
              Kayıt Olmadan Devam Et
            </Button>
          </Link>
        )}

        <Link href={loginHref} className="w-full">
          <Button className="w-full h-12 text-sm font-semibold">
            Giriş Yap / Kayıt Ol
          </Button>
        </Link>
      </div>
    </div>
  );
};

export default AuthRequiredContent;
